import React from "react";

import SegmentsDashboard from "./SegmentsDashboard";

const SegmentsContainer = (props) => <SegmentsDashboard {...props} />;

export default SegmentsContainer;
